import { render, staticRenderFns } from "./icon-wrapper.vue?vue&type=template&id=a8f3a7b2&scoped=true"
import script from "./icon-wrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-wrapper.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./icon-wrapper.vue?vue&type=style&index=0&id=a8f3a7b2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f3a7b2",
  null
  
)

export default component.exports